let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cbwV8")).then(() => parcelRequire('czhzX'));